export { default as ImgViewer } from './img-viewer.component';
